import { useState, useEffect } from "react";

const navItems = ["Home", "About", "Products", "VPN", "Cleaner", "Contact"];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (id: string) => {
    const el = document.getElementById(id.toLowerCase());
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        <span
          className={`font-extrabold text-xl md:text-2xl tracking-widest cursor-pointer transition-colors duration-300 ${
            scrolled ? "text-gray-900" : "text-white"
          }`}
          onClick={() => handleNav("home")}
        >
          MAHHERC
        </span>

        {/* Desktop nav */}
        <ul className="hidden md:flex items-center gap-8 lg:gap-12">
          {navItems.map((item) => (
            <li key={item}>
              <button
                onClick={() => handleNav(item)}
                className={`text-sm uppercase tracking-widest font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  scrolled
                    ? "text-gray-600 hover:text-gray-900"
                    : "text-white/80 hover:text-white"
                }`}
              >
                {item}
              </button>
            </li>
          ))}
        </ul>

        {/* Mobile hamburger */}
        <button
          className={`md:hidden flex flex-col gap-1.5 cursor-pointer ${
            scrolled ? "text-gray-900" : "text-white"
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span
            className={`block w-6 h-0.5 transition-all duration-300 ${
              scrolled ? "bg-gray-900" : "bg-white"
            } ${menuOpen ? "rotate-45 translate-y-2" : ""}`}
          />
          <span
            className={`block w-6 h-0.5 transition-all duration-300 ${
              scrolled ? "bg-gray-900" : "bg-white"
            } ${menuOpen ? "opacity-0" : ""}`}
          />
          <span
            className={`block w-6 h-0.5 transition-all duration-300 ${
              scrolled ? "bg-gray-900" : "bg-white"
            } ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`}
          />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white/97 backdrop-blur-md border-t border-gray-100 px-6 py-4">
          {navItems.map((item) => (
            <button
              key={item}
              onClick={() => handleNav(item)}
              className="block w-full text-left py-3 text-sm uppercase tracking-widest font-medium text-gray-700 hover:text-gray-900 cursor-pointer"
            >
              {item}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
